export const OTP_STATE = {
  DEFAULT: 'default',
  PENDING: 'pending',
  COMPLETE: 'complete',
  FAILURE: 'failure',
};

export const OTP_LENGTH = 6;
